import TaskHeader from "components/task/header/TaskHeader";
import { Box } from "@mui/joy";
import MyValueCompassContent from "./MyValueCompassContent";
import NoticeBannerStatic from "../../common/NoticeBannerStatic";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../../recoil/userAtom";

export default function MyValueCompass({
  showPaymentModule,
}: {
  showPaymentModule: boolean;
}) {
  const user = useRecoilValue(userAtom);

  return (
    <>
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 100,
        }}
      >
        <TaskHeader taskKey={"valueCompass"} />
        {user?.role === "patient" && (
          <NoticeBannerStatic
            message={"프로그램이 진행되며 자동으로 완성됩니다."}
            type={"valueCompass"}
          />
        )}
      </Box>

      <div className="w-full h-full overflow-x-hidden">
        <MyValueCompassContent />
      </div>
    </>
  );
}
